/**
 * en-GB messages added by Phase 4 task C5 (docs/PHASE-4-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const c5EnGB = {};
//# sourceMappingURL=c5.js.map